import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function SmsTabInboundMessages() {
  return (
    <MDBox>
      <MDTypography variant="body2" color="text.secondary">
        Gelen SMS mesajları burada listelenecek.
      </MDTypography>
    </MDBox>
  );
}
